import { Observable } from "rxjs/Observable";
import { ReservationService } from "./../services/reservation-service/reservation.service";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "./../services/projects/projects.service";
import { Component, OnInit } from "@angular/core";
import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
import swal from "sweetalert2";

@Component({
  selector: "app-price-control",
  templateUrl: "./price-control.component.html",
  styleUrls: ["./price-control.component.css"],
})
export class PriceControlComponent implements OnInit {
  price_control_form: FormGroup;
  projects: any[];
  arrSearch: any;
  dataFromSearch: any;
  chosen_unit: any;
  types: any;
  phases: any;
  finishing_types: any;
  design_types: any;
  role: any = JSON.parse(window.localStorage.getItem("userProfile")).role;
  allStatus: any = [
    "All",
    "Available",
    "Not Available",
    "Blocked",
    "Temp Blocked",
    "Reserved",
    "Blocked By Me",
    "Pending Finance Action",
    "Re-pricing",
  ];
  floors: any = [
    {
      name: "Basement",
      value: "Basement",
    },
    {
      name: "Ground",
      value: "Ground",
    },
    {
      name: "1st Floor",
      value: "1st Floor",
    },
    {
      name: "2nd Floor",
      value: "2nd Floor",
    },
    {
      name: "3rd Floor",
      value: "3rd Floor",
    },
    {
      name: "4th Floor",
      value: "4th Floor",
    },
    {
      name: "5th Floor",
      value: "5th Floor",
    },
    {
      name: "6th Floor",
      value: "6th Floor",
    },
  ];

  constructor(
    private projectService: ProjectsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private fb: FormBuilder,
    private reservationService: ReservationService,
    private http: HttpClient,
    private projectsService: ProjectsService
  ) {}

  ngOnInit() {
    this.getProjects();
    this.getUnitTypes();
    this.getAllFinishingTypes();
    this.getDesignTypes();
  }

  getAllPhases() {
    this.phases = [];
    this.projects.forEach((project) => {
      this.phases = [...this.phases, ...project.phases];
    });
  }

  getAllFinishingTypes() {
    this.slimLoadingBarService.complete();
    this.projectsService.getAllFinishingTypes().subscribe(
      (res: any) => {
        this.finishing_types = res;
        console.log("finishing types", this.finishing_types);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getDesignTypes(project_id = null) {
    this.projectService.getDesignTypes(project_id).subscribe(
      (data) => {
        this.design_types = data;
        console.log("design types", this.design_types);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  createForm() {
    this.price_control_form = this.fb.group({
      project_id: ["", Validators.required],
      unit_type_id: [""],
      price_type: ["Percentage", Validators.required],
      price_value: ["", Validators.required],
      comment: [""],
      design_type: [""],
      building_number: [""],
      floor: [""],
      area_from: [""],
      bed_rooms: [""],
      area_to: [""],
      finishing_type_id: [""],
      phase_id: [""],
      status: [""],
      block_number: [""],
    });
    this.price_control_form.get("project_id").valueChanges.subscribe((val) => {
      console.log(val);
      if (val != "All") {
        this.price_control_form.addControl("unit_id", new FormControl(""));
      }
    });
  }

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let project_id: any = this.price_control_form.get("project_id").value;
    let data = {
      unit_serial: keyword,
    };
    if (keyword) {
      return this.http
        .post(`${baseUrl}units/${project_id}/search`, JSON.stringify(data))
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.serial);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getProjects() {
    this.reservationService.getProjects().subscribe(
      (res: any) => {
        this.projects = res;
        this.createForm();
        this.getAllPhases();
      },
      (err) => console.log(err)
    );
  }

  onSelectAllItems(field: string, items: any, key = "id") {
    this.price_control_form.controls[field].setValue(
      items.map((f) => "" + f[key])
    );
  }

  onClearAllItems(field: string) {
    this.price_control_form.controls[field].setValue([]);
  }

  selectUnit(unit_serial) {
    console.log(unit_serial);
    this.dataFromSearch.forEach((e) => {
      if (e.serial == unit_serial) {
        this.price_control_form.get("unit_id").patchValue(e.id);
      }
    });
    console.log(this.price_control_form.get("unit_id").value);
  }

  getUnitTypes() {
    this.slimLoadingBarService.start();
    this.projectService.getUnitTypes().subscribe(
      (data) => {
        this.types = data;
        console.log(this.types);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  submit() {
    let payload = this.price_control_form.value;
    payload.project_id = +payload.project_id;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.projectService.requestUnitPriceChange(payload).subscribe(
      (res: any) => {
        this.createForm();
        swal(res, "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/price-control/price-control.component.ts